import lang from "@/views/modules/Applications/language/en";
import breadcrumbs from "@/views/modules/Applications/MenuList.vue";
import loader from "@/views/shared/loading/Loading.vue";
import Datepicker from 'vuejs-datepicker';

export default {
    name: "list-applications",

    components: {
        breadcrumbs,
        Datepicker,
        loader,
    },
    data() {
        return {
            page: 1,
            search: '',
            selectedOption: '',
            sort: {
                order: 'desc',
                column: 'date_entered',
                relRef: '',
            },
            perPage: 10,
            loading: true,
            dataList: [],
            pagination: {
                currentPage: 0,
                perPage: 0,
                total: 0,
                totalPages: 0
            },
            lang: [],
            series: 1,
            table_head: [{
                label: lang.LBL_APPLICATION_NO,
                isSort: true,
                field_name: 'app_no'
            },
            {
                label: lang.LBL_PROJECT_TITLE,
                isSort: true,
                field_name: 'application_title'
            },
            {
                label: lang.LBL_OPP_TITLE,
                isSort: true,
                relRef:'applications_opportunitys',
                field_name: 'opportunity_title'
            },
            {
                label: lang.LBL_FUNDER,
                isSort: true,
                relRef:'applications_opportunitys',
                field_name: 'opportunity_funder'
            },
            {
                label: lang.LBL_SCHEME_TYPE,
                isSort: true,
                relRef:'applications_opportunitys',
                field_name: 'opportunity_type'
            },
            // {
            //     label: lang.LBL_COUNTRY,
            //     isSort: false,
            //     relRef:'applications_opportunitys',
            //     field_name: 'country_name'
            // },
            {
                label: lang.LBL_OPPORTUNITY_BY,
                isSort: false,
                relRef:'applications_opportunitys',
                field_name: 'name'
            },
            {
                label: lang.LBL_APPLICATION_BY,
                isSort: true,
                relRef:'applications_users',
                field_name: 'name'
            },
            {
                label: lang.LBL_APPLICATION_DATE,
                isSort: true,
                field_name: 'date_entered'
            },
            {
                label: lang.LBL_STAGE,
                isSort: true,
                field_name: 'status'
            }
            ]
        }
    },
    mounted() {
        this.getProducts();
        this.lang = lang;
        this.dom_array = this.domArrayVariable;
    },
    methods: {
        sortBy(field, relRef) {
            if (this.sort.column === field) {
                this.sort.order = this.sort.order === 'asc' ? 'desc' : 'asc';
            } else {
                this.sort.order = 'asc';
            }
            this.sort.column = field;
            this.sort.relRef = relRef;
           
            this.getProducts(this.search)
        },
        changePage(page) {
            const self = this;
            if ((page > 0) && (page <= self.pagination.totalPages) && (page !== self.page)) {
                self.page = page;
                self.getProducts();
            }
        },
        changeSort() {
            const self = this;
            if (self.sort.order === 'asc') {
                self.sort.order = 'desc';
            } else if (self.sort.order === 'desc') {
                self.sort.order = 'asc';
            }
            self.getProducts();
        },
        getProducts(search = '') {
            const self = this;
            self.loading = true;

            const storedFilters = localStorage.getItem('filters');
            
            if (storedFilters !== '') {
                self.search=storedFilters;
            }

            if (search != '') {
                self.search = search;
            }
             window.currentAction = 'list';
                axios.get('api/modules/applications', {
                params: {
                    page: self.page,
                    sort: self.sort,
                    search: self.search,
                    perPage: self.perPage
                }
            }).then(function (response) {
                self.dataList = response.data.items;
                self.pagination = response.data.pagination;
                if (self.pagination.totalPages < self.pagination.currentPage) {
                    self.page = self.pagination.totalPages;
                    self.getProducts();
                } else {
                    self.loading = false;
                }
            }).catch(function () {
                self.loading = false;
            });
        },
        exportData() {
            const selectedValues = []
            this.records = {
                module: 'Applications',
                ids: selectedValues,
                callingFrom: 'export',
                all: this.selectedOption,
                search: this.search,
            }

            axios.post('api/export', this.records).then(function (response) {
                var link = document.createElement('a');
                link.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(response.data);
                link.download = 'data.csv';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }).catch(function () {
                self.loading = false;
            });
        },

    }
}
